import type { ApiPaths, JsonRequestBody, JsonResponse } from '~/src/shared/api';
import { getApiFetchInstance, useApiAccessToken } from '~/src/shared/api';
import { useCurrentOrganizationId } from '~/src/shared/lib/current-user';

export type AdminOrganizationInvitationsQuery = Exclude<ApiPaths['/admin/v1']['/organization-invitations']['get']['parameters']['query'], undefined>;

export function useInvitationsRepo() {
    const accessToken = useApiAccessToken();
    const authenticatedFetch = getApiFetchInstance(accessToken);
    return {
        async acceptOne(invitation_code: string, body: JsonRequestBody<ApiPaths['/core/v1']['/organization-invitations/{invitation_code}/accept']['post']>) {
            return authenticatedFetch<JsonResponse<ApiPaths['/core/v1']['/organization-invitations/{invitation_code}/accept']['post'], 200>>(`/core/v1/organization-invitations/${invitation_code}/accept`, {
                method: 'POST',
                body: body,
            });
        },

        async checkOne(invitation_code: string) {
            return authenticatedFetch<JsonResponse<ApiPaths['/core/v1']['/organization-invitations/{invitation_code}/check']['get'], 200>>(`/core/v1/organization-invitations/${invitation_code}/check`);
        },
    };
}

export async function useAdminInvitationsRepo() {
    const accessToken = useApiAccessToken();
    const organizationID = await useCurrentOrganizationId();

    const authenticatedFetch = getApiFetchInstance(accessToken, organizationID.value);
    return {
        async getAll(query: AdminOrganizationInvitationsQuery = {}) {
            return authenticatedFetch<JsonResponse<ApiPaths['/admin/v1']['/organization-invitations']['get'], 200>>(`/admin/v1/organization-invitations`);
        },

        async sendOne(invitation: JsonRequestBody<ApiPaths['/admin/v1']['/organization-invitations']['post']>) {
            return authenticatedFetch<JsonResponse<ApiPaths['/admin/v1']['/organization-invitations']['post'], 201>>(`/admin/v1/organization-invitations`, {
                method: 'POST',
                body: invitation,
            });
        },

        async getOne(invitation_id: string) {
            return authenticatedFetch<JsonResponse<ApiPaths['/admin/v1']['/organization-invitations/{invitation_id}']['get'], 200>>(`/admin/v1/organization-invitations/${invitation_id}`);
        },

        async resendOne(invitation_id: string) {
            return authenticatedFetch<null>(`/admin/v1/organization-invitations/${invitation_id}/message`, {
                method: 'POST',
            });
        },

        async revokeOne(invitation_id: string) {
            return authenticatedFetch<JsonResponse<ApiPaths['/admin/v1']['/organization-invitations/{invitation_id}/revoke']['post'], 200>>(`/admin/v1/organization-invitations/${invitation_id}/revoke`, {
                method: 'POST',
            });
        },

    }
}